export class RsjInstructionSituationDto {
  public rsjSituationId: number;
  public comment: string;
}
